import { makeStyles } from 'tss-react/mui';
import { Variant } from '../typography.types';
import { variantStyles } from './typography.styles.const';

export interface UseTypographyStylesParams {
  variant: Variant;
}

export const useTypographyStyles = makeStyles<UseTypographyStylesParams>()((_, props) => ({
  variant: variantStyles[props.variant],
}));
